import { Auth0ContextInterface } from "@auth0/auth0-react";
import IAuth0User from "./IAuth0User";

export class Auth0Service {
	private auth0: Auth0ContextInterface;

	constructor(auth0: Auth0ContextInterface) {
		this.auth0 = auth0;
	}

	public isAuthenticated(): boolean {
		return this.auth0.isAuthenticated;
	}

	public isLoading(): boolean {
		return this.auth0.isLoading;
	}

	public getUser(): IAuth0User | undefined {
		return this.auth0.user as IAuth0User;
	}

	public async getAccessToken(): Promise<string | undefined> {
		try {
			return await this.auth0.getAccessTokenSilently();
		} catch (error) {
			console.error("Error getting access token:", error);
			return undefined;
		}
	}

	public getAuth0Instance(): Auth0ContextInterface {
		return this.auth0;
	}

	public async getIdToken(): Promise<string | undefined> {
		try {
			return await this.auth0
				.getIdTokenClaims()
				.then((claims) => claims?.__raw);
		} catch (error) {
			console.error("Error getting ID token:", error);
			return undefined;
		}
	}

	public loginWithRedirect(): void {
		this.auth0.loginWithRedirect();
	}

	public logout(): void {
		this.auth0.logout({
			logoutParams: {
				returnTo: window.location.origin,
			},
		});
	}

	public getUserRoles(): string[] {
		const user = this.getUser();
		// Check all possible role locations (handle double slash issue)
		return (
			user?.["https://arteh.com.au/roles"] ||
			user?.["https://arteh.com.au//roles"] ||
			user?.roles ||
			[]
		);
	}

	public hasRole(role: string): boolean {
		return this.getUserRoles().includes(role);
	}
}

export default Auth0Service;
